var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexFeatured/IndexFeatured.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += " ";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexFeatured/IndexFeatured.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"IndexFeatured\">\n\n        <div class=\"IndexFeatured-members\">\n            ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("member", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"member")),"popupUrl"), env.opts.autoescape);
t_5 += "\" class=\"IndexFeatured-membersItem\"  data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") * 200, env.opts.autoescape);
t_5 += "\">\n                    <div class=\"IndexFeatured-membersItemImg\">\n                        <img src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_9),"portfolio")),"cover")),"w680_url"), env.opts.autoescape);
t_5 += "\"\n                            srcset=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_9),"portfolio")),"cover")),"w920_url"), env.opts.autoescape);
t_5 += " 2x\"\n                            alt=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"member")),"fullName"), env.opts.autoescape);
t_5 += "\">\n                    </div>\n                    <h3>";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"member")),"fullName"), env.opts.autoescape);
t_5 += "</h3>\n                    <div class=\"IndexFeatured-membersItemText\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"member")),"classificationsString"), env.opts.autoescape);
t_5 += "</div>\n                    <div class=\"IndexFeatured-membersItemArrow\">\n                        ";
t_5 += runtime.suppressValue((lineno = 16, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_5 += "\n                    </div>\n                </a>\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n        </div>\n\n        <a href=\"";
t_5 += runtime.suppressValue((lineno = 22, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:members"])), env.opts.autoescape);
t_5 += "\" class=\"IndexFeatured-allMembers\">All Members</a>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("IndexFeatured");
context.setVariable("IndexFeatured", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexFeatured/IndexFeatured.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexFeatured/IndexFeatured.jinja
// module id = 493
// module chunks = 0